// hooks/useOutsideClick.js
import { useEffect, useRef } from "react";

function useOutsideClick(handler, enabled = true) {
  const ref = useRef();
  const handlerRef = useRef(handler);

  // Keep handler ref current to avoid stale closures
  useEffect(() => {
    handlerRef.current = handler;
  });

  useEffect(() => {
    if (!enabled) return;

    const handleEvent = (event) => {
      // If ref doesn't exist or contains the clicked element, don't trigger
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      // Check if target still exists in DOM (handles dynamic content)
      if (!document.contains(event.target)) {
        return;
      }

      // the handler (inside handlerRef.current) is the "onSave" function we're passing from outside
      handlerRef.current(event);
    };

    // Use capture phase to ensure we handle the event before other handlers
    document.addEventListener("mousedown", handleEvent, true);
    document.addEventListener("touchstart", handleEvent, true);

    return () => {
      document.removeEventListener("mousedown", handleEvent, true);
      document.removeEventListener("touchstart", handleEvent, true);
    };
  }, [enabled]);

  return ref;
}

export default useOutsideClick;
